<template>
  <div class="container">
    <loading-component v-if="isLoading" />
    <no-result-component
      v-else-if="computedContestants == null || computedContestants.length <= 0"
    />
    <div v-else>
      <page-title-component title="Votes summary" :subtitle="competitionName" />
      <section class="section">
        <div class="container">
          <b-table :data="computedContestants" ref="table" :striped="true">
            <template slot-scope="props">
              <b-table-column field="placing" label="Placing" sortable>{{ props.row.placing }}</b-table-column>
              <b-table-column field="keyword" label="Keyword" sortable>{{ props.row.keyword }}</b-table-column>

              <b-table-column
                field="brewId"
                label="Brew"
                sortable
              >{{ getBrewName(props.row.brewId) }}</b-table-column>

              <b-table-column
                field="createdDate"
                label="Created"
                sortable
              >{{ formatDateTime(props.row.createdDate) }}</b-table-column>
            </template>
          </b-table>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import apiService from "./../services/apiService";
import LoadingComponent from "./Loading.vue";
import NoResultComponent from "./NoResult.vue";
import PageTitleComponent from "./PageTitle.vue";
var moment = require("moment");
moment().format();
export default {
  name: "votes-summary",
  components: {
    LoadingComponent,
    NoResultComponent,
    PageTitleComponent
  },
  props: {
    competitionId: String,
    competitionName: String,
    apiKey: String
  },

  data() {
    return {
      isLoading: false,
      onlyCompetitionEntries: false,
      votes: [],
      brews: []
    };
  },
  async created() {
    this.isLoading = true;
    try {
      await this.fetch();
    } catch (err) {
      console.log(err);
    } finally {
      this.isLoading = false;
    }
  },
  methods: {
    getBrewName(brewId) {
      var brew = this.brews.find(function(brew) {
        return brew.id == brewId;
      });

      if (brew) {
        return brew.title;
      } else {
        return "---";
      }
    },

    formatDateTime(datetime) {
      return moment(datetime).format("YYYY-MM-DD HH:mm:ss");
    },

    async fetch() {
      var self = this;
      if (this.apiKey) {
        var managerToken = {
          competitionId: this.competitionId,
          apiKey: this.apiKey
        };
        apiService
          .getVotes(managerToken)
          .then(response => {
            this.$toast.open({
              message: "Vote summary fetched",
              type: "is-success",
              position: "is-bottom"
            });
            self.votes = response.data;
          })
          .catch(err => {
            this.$toast.open({
              message: err.response.data,
              type: "is-danger",
              position: "is-bottom"
            });
          });

        const brewData = await apiService.getBrewsForCompetition(
          self.competitionId
        );
        self.brews = brewData.data;
      }
    },
    toggle(row) {
      this.$refs.table.toggleDetails(row);
    }
  },
  computed: {
    computedContestants() {
      var self = this;
      return self.votes;
    }
  }
};
</script>
